import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { supabase } from '../lib/supabase.js';

export default function ProtectedClientRoute({ children }) {
  const [session, setSession] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    supabase.auth.getSession().then(({ data: { session: s } }) => {
      if (isMounted) { setSession(s); setLoading(false); }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, s) => {
      if (event === 'INITIAL_SESSION') return;
      if (isMounted) setSession(s);
    });

    return () => { isMounted = false; subscription.unsubscribe(); };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader size={24} className="animate-spin text-gray-400" />
      </div>
    );
  }

  if (!session) return <Navigate to="/client/login" replace />;
  return children;
}
